// extracted by extract-css-chunks-webpack-plugin
module.exports = {"inputWrapper":"StripeElementWrapper-2ef391bfe5cc2ae4","inputLabel":"StripeElementWrapper-6b84f235ee193415"};